export const FREE_SHIPPING_THRESHOLD = 179900
export const STANDARD_DELIVERY_TYPE = 'standard-delivery'
export const CASH_ON_DELIVERY_TYPE = 'cash-on-delivery'
export const COLLECT_IN_STORE_DELIVERY_TYPE = 'collect-in-store'

export const DELIVERY_TYPES_NAME = {
  [STANDARD_DELIVERY_TYPE]: 'Recibir compra',
  [CASH_ON_DELIVERY_TYPE]: 'Pago contra entrega',
  [COLLECT_IN_STORE_DELIVERY_TYPE]: 'Retirar compra'
}

export const DELIVERY_STATUS_PENDING = 'pending'
export const DELIVERY_STATUS_IN_PROGRESS = 'in-progress'
export const DELIVERY_STATUS_DELIVERED = 'delivered'
export const DELIVERY_STATUS_RETURNED = 'returned'

const DELIVERY_STATUS_TITLE = {
  [DELIVERY_STATUS_IN_PROGRESS]: 'Despachado',
  [DELIVERY_STATUS_DELIVERED]: 'Entregado',
  [DELIVERY_STATUS_RETURNED]: 'Devuelto'
}

const DELIVERY_STATUS_NAME = {
  [DELIVERY_STATUS_PENDING]: 'En preparación',
  [DELIVERY_STATUS_IN_PROGRESS]: 'En camino',
  [DELIVERY_STATUS_DELIVERED]: 'Entregado',
  [DELIVERY_STATUS_RETURNED]: 'Devuelto'
}

const DELIVERY_STATUS_DEFAULT_DESCRIPTION = {
  [DELIVERY_STATUS_PENDING]: 'La tienda está preparando tu paquete.',
  [DELIVERY_STATUS_IN_PROGRESS]: 'Tu paquete está en viaje.',
  [DELIVERY_STATUS_DELIVERED]: 'Entregamos el paquete.',
  [DELIVERY_STATUS_RETURNED]: 'Se realizó la devolución del paquete.'
}

const DELIVERY_TYPES_DESCRIPTION = {
  [STANDARD_DELIVERY_TYPE]: 'Entrega en el domicilio del comprador',
  [CASH_ON_DELIVERY_TYPE]: 'Entrega en el domicilio del comprador',
  [COLLECT_IN_STORE_DELIVERY_TYPE]: 'El comprador recogerá el paquete'
}

export function getDeliveryTypeName (deliveryType) {
  return DELIVERY_TYPES_NAME[deliveryType] ? DELIVERY_TYPES_NAME[deliveryType] : deliveryType
}

export function getDeliveryTypeDescription (deliveryType) {
  return DELIVERY_TYPES_DESCRIPTION[deliveryType] ? DELIVERY_TYPES_DESCRIPTION[deliveryType] : deliveryType
}

export function deliveryIsFree (delivery, totalCost) {
  if (delivery.cost === 0) {
    return true
  }

  if (delivery.delivery_type === CASH_ON_DELIVERY_TYPE) {
    return false
  }

  return totalCost >= FREE_SHIPPING_THRESHOLD
}

export function getDeliveryStatusTitle (status) {
  return DELIVERY_STATUS_TITLE[status] ? DELIVERY_STATUS_TITLE[status] : 'Comprado'
}

export function getDeliveryStatusName (status) {
  return DELIVERY_STATUS_NAME[status] ? DELIVERY_STATUS_NAME[status] : status
}

export function getDeliveryStatusDescription (description, status) {
  if (description) {
    return description
  }

  return DELIVERY_STATUS_DEFAULT_DESCRIPTION[status] ? DELIVERY_STATUS_DEFAULT_DESCRIPTION[status] : description
}
